var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navbar-notifications",
      style: {
        top: _vm.top,
        right: _vm.right,
        bottom: _vm.bottom,
        left: _vm.left
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "notifications-card",
          attrs: { width: "415px", height: _vm.notificationsCardHeight }
        },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "d-flex",
              attrs: { height: "60", id: "navbar-notifications-header" }
            },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "notifications-card-title" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("Notifications")) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.orderedMessages.length > 0
            ? _c(
                "div",
                { staticClass: "menu-position" },
                [
                  _c("notifications-menu", {
                    attrs: { viewAll: true, allRead: _vm.allRead },
                    on: {
                      readAllNotifications: _vm.readUnreadAllNotifications,
                      deleteAllNotifications: _vm.deleteAllNotifications
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list",
            {
              class: {
                scroll: _vm.viewAll,
                "no-messages": _vm.orderedMessages.length === 0
              },
              attrs: {
                "three-line": "",
                height: _vm.notificationsSectionHeight
              }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.orderedMessages.length === 0,
                      expression: "orderedMessages.length === 0"
                    }
                  ]
                },
                [_vm._v("No Notifications")]
              ),
              _vm._v(" "),
              _vm._l(_vm.orderedMessages, function(notification, index) {
                return [
                  _c(
                    "v-list-item",
                    {
                      key: notification.id,
                      class: { read: notification.readAt },
                      attrs: { id: "navbar-notifications-list" }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        { attrs: { height: "50px", width: "50px", tile: "" } },
                        [
                          notification.topic !== "system"
                            ? _c("v-img", {
                                attrs: {
                                  src: _vm.getImageUrl(
                                    notification.body.createdBy
                                  )
                                }
                              })
                            : _c("v-img", {
                                attrs: {
                                  src: _vm.getImageUrl(notification.userId)
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "text-left" },
                            [
                              _c("span", { staticClass: "text--primary" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.getUserName(
                                        notification.body.createdBy
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text--secundary" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.getNotificationMessage(
                                        notification.body.type
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              notification.topic === "system"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-content-space-between"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "text--secundary link",
                                          attrs: {
                                            href: notification.body.url,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(notification.body.message)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-action",
                        { key: index },
                        [
                          _c("notifications-menu", {
                            attrs: {
                              notification: notification,
                              viewAll: false
                            },
                            on: {
                              redirectToTask: function($event) {
                                return _vm.redirectToTask($event)
                              },
                              readNotification: function($event) {
                                return _vm.readNotification($event)
                              },
                              deleteNotification: function($event) {
                                return _vm.deleteNotification($event)
                              },
                              unReadNotification: function($event) {
                                return _vm.unReadNotification($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("view-all-button", {
            attrs: { socketMessage: _vm.socketMessage, viewAll: _vm.viewAll },
            on: {
              viewAll: function($event) {
                _vm.viewAll = !_vm.viewAll
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34e61416", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e61416","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Notifications/NotificationsWindow.vue
// module id = null
// module chunks = 